import React from 'react';
import Footer from './Footer';
import './Home.css';

function Home() {
    return (
        <div className="home">
            {/* Hero Section */}
            <section className="hero">
                <div className="hero-image-layer" aria-hidden="true"></div>
                <div className="hero-content">
                    <p className="pre-title">Together with their families</p>
                    <h1 className="couple-names">Alysia & Thomas</h1>
                    <div className="divider">
                        <span className="divider-line"></span>
                        <span className="divider-icon">♥</span>
                        <span className="divider-line"></span>
                    </div>
                    <p className="invitation-text">Request the pleasure of your company at their wedding celebration</p>
                </div>
            </section>

            {/* Date & Location Section - Elegant Minimalist */}
            <section className="botanical-wrapper">
                <div className="botanical-left"></div>
                <div className="botanical-right"></div>

                <section className="details">
                    <div className="details-content">
                        <span className="corner-flourish top-left">❦</span>
                        <span className="corner-flourish top-right">❦</span>
                        <span className="corner-flourish bottom-left">❦</span>
                        <span className="corner-flourish bottom-right">❦</span>

                        <div className="details-split">
                            <div className="date-column">
                                <p className="event-date">Saturday</p>
                                <p className="event-date-full">September 12th, 2026</p>
                            </div>

                            <div className="details-divider">
                                <span className="vertical-line"></span>
                                <span className="ornament-symbol">✦</span>
                                <span className="vertical-line"></span>
                            </div>

                            <div className="location-column">
                                <p className="venue-location">New Marlborough</p>
                                <p className="venue-state">Massachusetts</p>
                            </div>
                        </div>
                    </div>
                </section>

                {/* Welcome Message - Soft integrated styling */}
                <section className="welcome">
                    <div className="welcome-content">
                        <p className="welcome-text">
                            The Berkshires have long been a summer retreat from the bustle of the Northeastern cities.
                            They are also a favorite gathering place for Thomas's family, where Alysia has lately 
                            joined them in sledding, maple surgaring, and splitting firewood for the stove at Thomas's 
                            grandparents' house. 
                        </p>
                        <p className="welcome-text">
                            For Alysia, the Berkshires evoke their grander, wilder counterparts of the same appalachian 
                            range in Western North Carolina, where she grew up hiking, camping, and climbing everything
                            with her family and her childhood dog Gizmo.
                        </p>
                        <p className="welcome-closing">
                            We look forward to sharing this place and moment with you!
                        </p>
                    </div>
                </section>

            </section>

            {/* Footer */}
            <Footer />
        </div>
    );
}

export default Home;
